export default {
  positive: 'Positive',
  neutral: 'Neutral',
  negative: 'Negative',
  notClassified: 'Not Classified',
  showAllThemes: 'All themes',
};
